<div class="">
    <div class="main_content">
        <app-breadcrumb></app-breadcrumb>
        <div class="row">
            <div class="col-lg-7">
                <div class="urn_details_sec">
                    <div class="urn_details">
                        <span class="nav_prev_btn">
                            <i class="material-icons text-success">check</i>
                        </span>
                        <ul class="urn_details_ul">
                            <li class="urndetail_li blue_box">
                                <p class="urn_title">Project</p>
                                <p class="urn_content">{{doaDetail.project}}</p>
                            </li>
                            <li class="urndetail_li blue_box">
                                <p class="urn_title">Region</p>
                                <p class="urn_content">{{doaDetail.region}}</p>
                            </li>
                            <li class="urndetail_li blue_box">
                                <p class="urn_title">Business Unit</p>
                                <p class="urn_content">
                                    {{doaDetail.businessUnit}}
                                </p>
                            </li>
                            <li class="urndetail_li blue_box">
                                <p class="urn_title">Country</p>
                                <p class="urn_content">{{doaDetail.country}}</p>
                            </li>
                            <li class="urndetail_li blue_box">
                                <p class="urn_title">Document</p>
                                <p class="urn_content">{{doaDetail.document}}</p>
                            </li>
                        </ul>
                        <span class="nav_next_btn" (click)="isDisplayDocModel=true;isOpenDoctypeModel=true">
                            <i class="material-icons text-primary">edit</i>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3">
                <div class="settingBar_Sec">
                    <div class="setting_sec" (click)="isDisplaySettingData=true" [ngClass]="isDisplaySettingData==true?'activeBox':''">
                        <span>
                            <i class="material-icons">format_indent_decrease</i>
                        </span>
                        <p class="settingTitle">Settings</p>
                    </div>
                    <div class="setting_sec" (click)="isDisplaySettingData=false" [ngClass]="isDisplaySettingData==false?'activeBox':''">
                        <span>
                            <i class="material-icons">file_upload</i>
                        </span>
                        <p class="settingTitle">Excel Upload</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="page_main_sec">
            <div *ngIf="isDisplaySettingData" class="row selection-sec " style="margin-top: 10px;">
                <div>
                    <p class="contentTitle">Delegation of Authority Settings</p>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="card" style="margin-bottom: 10px; margin-left: 20px;">
                            <div class="card-header">
                                <h3 class="card-titile carousel_title">Rule Name: R1</h3>
                            </div>
                            <div class="card-body container">
                                <table width="100%" class="invisible-table">
                                    <tbody>
                                        <tr>
                                            <td width="15%">Process:</td>
                                            <td width="25%" class="overflow-text"><span class="dataValue">Pending for
                                                    Approval</span></td>
                                            <td width="12%">Parallel:</td>
                                            <td width="13%" class="overflow-text"><span class="dataValue">No</span></td>
                                            <td width="15%">Anyone can Approve:</td>
                                            <td width="10%" class="overflow-text"><span class="dataValue">Yes</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Next Process:</td>
                                            <td class="overflow-text"><span class="dataValue">Approved</span></td>
                                            <td>Header Level:</td>
                                            <td class="overflow-text"><span class="dataValue">Yes</span></td>
                                            <td>Line Level:</td>
                                            <td class="overflow-text"><span class="dataValue">No</span></td>
                                        </tr>
                                        <tr>
                                            <td>Rejected Process:</td>
                                            <td class="overflow-text"><span class="dataValue"></span></td>
                                            <td>Amount Based:</td>
                                            <td class="overflow-text"><span class="dataValue">Yes</span></td>
                                            <td>Status:</td>
                                            <td class="overflow-text"><span class="dataValue">ACTIVE</span></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div class="card_action_buttons">
                                    <a class="matrixHeader mx-2">Show Approvers <i id="detailsIcon"
                                        class="material-icons">arrow_downward</i></a>
                                </div>
                                <div class="">
                                    <app-basic-gridview [lstData]="lstDOASetting" [gridTitle]=""
                                        [showExcelDownloadOption]="false" [showSearchOption]="false"
                                        [showRecordsPerPageOption]="false" [showPagination]="false">
                                    </app-basic-gridview>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div *ngIf="!isDisplaySettingData" class="row selection-sec " style="margin-top: 10px;">
                <div>
                    <p class="contentTitle">Delegation of Authority Excel Upload</p>
                </div>
                <div class="row">
                    <div class="col-lg-11">
                        <div [style.width.%]="100">
                            <mat-toolbar class="matBG">
                                <input type="text" [hidden]="true">
                                <mat-label [attr.title]="fileTitle" class="file-names">{{selectedFile}}</mat-label>
                                <button class="Mat_btn_Custom_Width" type="button" mat-flat-button color="primary"
                                    (click)="invFileUpload.click()">
                                    Choose file
                                </button>
                                <div class="upload_btn_sec" (click)="uploadFile()">
                                    <img src="../../../assets/img/transaction/upload.png" alt="Upload">
                                </div>
                            </mat-toolbar>
                            <input [attr.type]="fileControlType" #invFileUpload (change)="onSelectFile($event)"
                                hidden />
                        </div>
                    </div>
                    <div class="col-lg-1" (click)="downloadTemplate()">
                        <span class="download-template-wrp">
                            <span><i class="material-icons">file_download</i></span> TEMPLATE
                        </span>
                    </div>
                </div>

                <div class="row">
                    <div class="">
                        <app-basic-gridview [lstData]="lstDOAExelUpload" [gridTitle]=""
                            [showExcelDownloadOption]="false" [showSearchOption]="false"
                            [showRecordsPerPageOption]="false" [showPagination]="false">
                        </app-basic-gridview>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="isDisplayDocModel" class="doctype-model" [class.doctype-model-closed]="!isOpenDoctypeModel">
    <div class="bx">
        <div class="title-wrap">
            <p>Document Type</p>
            <button mat-icon-button class="dialog-close-button" (click)="isOpenDoctypeModel=false">
                <mat-icon class="close-icon" color="warn">close</mat-icon>
            </button>
        </div>
        <ul class="selection-list">
            <li [class.selected]="selectedDocumentType.docTypeId == docType.docTypeId"
                *ngFor="let docType of docTypeList" (click)="onChangeDoctype(docType)">
                <div class="selected-check">{{docType.docTypeName}}</div>
            </li>
        </ul>
    </div>
</div>